import React, { Component } from 'react';
import { ScrollView, StatusBar, Platform } from 'react-native';
import Modal from 'react-native-modal';
import { request, PERMISSIONS } from 'react-native-permissions';

import PropTypes from 'prop-types';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../FrameworkTestKeys';

import styles from './BackgroundLocationOverlay.Styles';
import {
  getBackgroundOverlayVisibility,
  openSettings,
  checkForegroundLocationPermissionsGranted,
  checkBackgroundLocationPermissionGranted,
} from './BackgroundLocationOverlay.Utils';
import DetailsScreen from './Components/DetailsScreen';
import Header from './Components/Header';
import InitialScreen from './Components/InitialScreen';

class BackgroundLocationOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isIntialScreenActive: true,
      isBackButtonVisible: false,
      isOverlayVisible: !!props.isVisible,
    };
  }

  componentDidMount() {
    this.triggerOnVisibleStatusChange();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isVisible !== prevProps.isVisible) {
      this.setState({ isOverlayVisible: this.props.isVisible });
    }
  }

  onPrimaryButtonPress = async () => {
    if (
      (await checkForegroundLocationPermissionsGranted()) &&
      !(await checkBackgroundLocationPermissionGranted())
    ) {
      await request(PERMISSIONS.ANDROID.ACCESS_BACKGROUND_LOCATION);
    } else {
      openSettings();
    }
    this.dismissOverlay();
  };

  toggleScreens = () => {
    this.setState({
      isIntialScreenActive: !this.state.isIntialScreenActive,
      isBackButtonVisible: !this.state.isBackButtonVisible,
    });
  };

  triggerOnVisibleStatusChange = async () => {
    this.props.onVisibleStatusChange(
      await getBackgroundOverlayVisibility(this.state.isOverlayVisible),
    );
  };

  dismissOverlay = () => {
    this.setState({ isOverlayVisible: false });
    this.props.onVisibleStatusChange(false);
  };

  canDisplayOverlay = () =>
    Platform.OS === 'android' &&
    Platform.Version >= 30 &&
    this.props.isBackgroundLocationDeclaredOnManifest &&
    this.state.isOverlayVisible;

  render() {
    return this.canDisplayOverlay() ? (
      <>
        <StatusBar hidden />

        <Modal propagateSwipe isVisible style={styles.containerStyle(this.props.theme)}>
          <ScrollView
            style={styles.scrollViewContainerStyle}
            testID={FrameworkTestKeys.BLOScrollView}
          >
            <Header
              withBackButton={this.state.isBackButtonVisible}
              onBackPress={this.toggleScreens}
              onClosePress={this.dismissOverlay}
            />

            {this.state.isIntialScreenActive ? (
              <InitialScreen
                onPrimaryButtonPress={this.onPrimaryButtonPress}
                onClosePress={this.dismissOverlay}
                onLearnMorePress={this.toggleScreens}
              />
            ) : (
              <DetailsScreen
                onPrimaryButtonPress={this.onPrimaryButtonPress}
                onPrivacyPolicyPress={this.props.onPrivacyPolicyPress}
              />
            )}
          </ScrollView>
        </Modal>
      </>
    ) : null;
  }
}

BackgroundLocationOverlay.defaultProps = {
  isBackgroundLocationDeclaredOnManifest: true,
  theme: LightThemeColors,
  offsetDays: 30,
};

BackgroundLocationOverlay.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isBackgroundLocationDeclaredOnManifest: PropTypes.bool,
  onPrivacyPolicyPress: PropTypes.func,
  onVisibleStatusChange: PropTypes.func,
  offsetDays: PropTypes.number,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(BackgroundLocationOverlay);
